import React from "react";
import { GridGenerator } from "@actinc/dls";
import { Button } from "@mui/material";
import { useForm } from "react-hook-form";

import {
  AlertDialog,
  ControlledFormInput,
  ControlledFormSelect,
} from "../../../../components";

const AddItemDialog = ({
  defaultValues = {},
  developmentStates,
  itemFormats,
  itemWriterOptions,
  onClose,
}) => {
  const { control, formState, getValues } = useForm({
    defaultValues,
    mode: "all",
    reValidateMode: "onBlur",
  });

  const { isValid } = formState;

  const handleCancel = () => {
    onClose(null);
  };

  const handleClose = () => {
    onClose({
      ...getValues(),
    });
  };

  const newItemDialogProps = {
    dialogTitle: "Add Item",
    dialogBody: (
      <>
        <GridGenerator
          groups={[
            [
              {
                children: (
                  <ControlledFormInput
                    control={control}
                    id="contentArea"
                    label="Content Area"
                    name="contentArea"
                    readonly="true"
                    rules={{ required: true }}
                  />
                ),
                key: `addItem-contentArea`,
              },
              {
                children: (
                  <ControlledFormInput
                    control={control}
                    id="contentSpecialist"
                    label="Content Specialist"
                    name="contentSpecialist"
                    readonly="true"
                    rules={{ required: true }}
                  />
                ),
                key: `addItem-contentSpecialist`,
              },
            ],
            [
              {
                children: (
                  <ControlledFormSelect
                    control={control}
                    fullWidth={true}
                    id="itemWriter"
                    label="Item Writer"
                    name="itemWriter"
                    options={itemWriterOptions}
                  />
                ),
                key: `addItem-itemWriter`,
              },
              {
                children: (
                  <ControlledFormSelect
                    control={control}
                    fullWidth={true}
                    id="format"
                    label="Item Format"
                    name="format"
                    options={itemFormats}
                    rules={{
                      required: true,
                    }}
                  />
                ),
                key: `addItem-itemFormat`,
              },
            ],
          ]}
        />
      </>
    ),
    customFooter: (
      <>
        <Button onClick={handleCancel} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleClose}
          disabled={!isValid}
          variant="contained"
          type="submit"
        >
          Add Item
        </Button>
      </>
    ),
    fullWidth: false,
    maxWidth: "sm",
    open: true,
  };

  return (
    <AlertDialog {...newItemDialogProps}>
      <form>{newItemDialogProps.dialogBody}</form>
    </AlertDialog>
  );
};

export { AddItemDialog };
